import axios from 'axios'

const CounselingChatService = {
  async requestSession (data = {}) {
    return axios.post('shared/counseling-chat/sessions/request', data)
  },

  async getState () {
    return axios.get('shared/counseling-chat/sessions/state')
  },

  async getSession (sessionId) {
    return axios.get(`shared/counseling-chat/sessions/${sessionId}`)
  },

  async acceptSession (sessionId) {
    return axios.post(`shared/counseling-chat/sessions/${sessionId}/accept`)
  },

  async sendMessage (sessionId, message = '', fileInfo = null) {
    const payload = {
      message
    }

    if (fileInfo) {
      payload.file_info = fileInfo
    }

    return axios.post(`shared/counseling-chat/sessions/${sessionId}/messages`, payload)
  },

  async uploadFile (sessionId, file, onUploadProgress = null) {
    const formData = new FormData()
    formData.append('file', file)

    return axios.post(`shared/counseling-chat/sessions/${sessionId}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },

  async downloadFile (sessionId, storedName) {
    return axios.get(
      `shared/counseling-chat/sessions/${sessionId}/download-file/${encodeURIComponent(storedName)}`,
      {
        responseType: 'blob'
      }
    )
  },

  async closeSession (sessionId, saveTranscript = true) {
    return axios.post(`shared/counseling-chat/sessions/${sessionId}/close`, {
      save_transcript: saveTranscript
    })
  },

  async getTranscripts (params = {}) {
    return axios.get('shared/counseling-chat/sessions/transcripts', { params })
  },

  async getTranscript (sessionId) {
    return axios.get(`shared/counseling-chat/sessions/${sessionId}/transcript`)
  },

  async getPendingReview () {
    return axios.get('shared/counseling-chat/sessions/pending-review')
  },

  async reviewTranscript (sessionId, keep = true) {
    return axios.post(`shared/counseling-chat/sessions/${sessionId}/transcript/review`, {
      keep
    })
  },

  async submitSessionFeedback (sessionId, data) {
    return axios.post(`shared/counseling-chat/sessions/${sessionId}/feedback`, data)
  }
}

export default CounselingChatService
